import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

@NgModule({
  schemas: [NO_ERRORS_SCHEMA],
})
export class DispatchPageModule {}
